// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wfNb","type":"styles_type__mB6y1","choices":"styles_choices__2g3yd"};